import splash from "../../static/images/splash/splash.jpeg";
import full from "../../static/images/logo/full.png";

interface Props {
  message?: string;
}

const Splash: React.FC<Props> = ({ message }) => {
  return (
    <div className="flex bg-pkc-white">
      <div className="absolute top-0 bottom-0 flex flex-col flex-1 w-full">
        <div
          className="bg-center bg-cover flex-2 bg-pkc-primary"
          style={{
            backgroundImage: `url('${splash}')`,
          }}
        />
        <div className="flex flex-col items-stretch flex-1 bg-pkc-white">
          <div className="flex flex-col items-center transform -translate-y-full border-t-2 border-l-2 rounded-tl-full border-pkc-primary bg-pkc-white">
            <img src={`${full}`} />
          </div>
          <div className="text-center">{message || "خوش آمدید"}</div>
        </div>
      </div>
    </div>
  );
};

export default Splash;
